/**
 * Users Routes
 */
/* eslint-disable */
import { Layout, Section } from 'layout';
import { Redirect, Route, Switch } from 'react-router-dom';

// async components
import { AsyncAppUsersFormComponent, AsyncAppUsersListComponent } from 'components/AsyncComponent';

const Forms = ({ match }) => {
  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={AsyncAppUsersListComponent} />
          <Route path={`${match.url}/edit/:id`} component={AsyncAppUsersFormComponent} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default Forms;
